module.exports = __webpack_public_path__ + "img/avatar4.96983f88.png";